var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['BaseDivider', { 'BaseDivider--dark': _vm.dark }]},[(_vm.$slots.default)?_c('span',{staticClass:"BaseDivider__content"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }